
<div class="row">
    <div *ngFor="let image of imageList; index as myCount" class="col-sm-2 col-md-4 text-center py-2">
        <a [routerLink]="['/info/gallery/preview',myCount]"  class="highlight">
        <div class="card px-5 py-5 h-100  text-center">
            <img src="{{image['url']}}.png" width="200px" >
        </div>
    </a>
    </div>
</div>
<app-country-level-syllabus></app-country-level-syllabus>

